angular.module('app.shared')
  .directive('discovererProgressChart', function () {
    return {
      restrict: 'E',
      templateUrl: '/app/shared/views/partials/discovererProgressChart.html',
    };
  });
